export default (): PhoneNumber => ({
  phoneNumberValue: {
    base: "",
    baseRaw: "",
    formatted: "",
    extension: ""
  }
})
